import type {ReactElement} from 'react';
import React from 'react';
import {BaseItemMultiplyOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-item-multiply-option';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromEffectsActiveItem} from '@Hooks/poster-editor/useGetKeyFromEffectsOfActiveItem';
import type {RGBA} from '@Utils/color.util';

interface ItemMultiplyOptionProps {
  onClickColorFill(): void;
}

export function ItemMultiplyOption({...props}: ItemMultiplyOptionProps): ReactElement<any> {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const activeItemMultiply = useGetKeyFromEffectsActiveItem('multiply');
  const activeItemMultiplyColor = useGetKeyFromEffectsActiveItem('multiplyColor');
  if (!activeItem || (activeItem && !('effects' in activeItem)) || activeItemMultiply === undefined || !activeItemMultiplyColor) {
    throw new Error(`Item doesn't have effects property`);
  }

  const onToggleMultiply = (): void => {
    void activeItem.updateFromObject({
      effects: {
        multiply: !activeItemMultiply,
      },
    });
  };

  const updateOpacity = (multiplyOpacity: number, undoable = true): void => {
    const multiplyColor = activeItemMultiplyColor.slice() as RGBA;
    multiplyColor[3] = multiplyOpacity;
    void activeItem.updateFromObject(
      {
        effects: {
          multiplyColor,
        },
      },
      {
        undoable,
      }
    );
  };

  return (
    <BaseItemMultiplyOption
      multiplyColor={activeItemMultiplyColor}
      multiply={activeItemMultiply}
      multiplyOpacity={activeItemMultiplyColor[3]}
      onClickColorFill={(): void => {
        props.onClickColorFill();
      }}
      onToggleMultiply={onToggleMultiply}
      updateOpacity={updateOpacity}
    />
  );
}
